import React, { useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

export const ApexChart: React.FC<any> = ({ AnserData }) => {
  const dispatch = useDispatch<any>();

  let series: {
    name: string;
    data: { x: number; y: number }[];
    type: string;
  }[] = [];
  let categories: string[] = [];
  let legends: string[] = [];
  if (AnserData !== null) {
    let dateScoresMap: { [date: string]: { [legend: string]: number } } = {};

    AnserData.forEach((answer: any) => {
      if (answer.questionType === "Multichoice" && answer.legend) {
        const date = answer.askedOn;
        console.log("date",date);
        if (!dateScoresMap[date]) {
          dateScoresMap[date] = {};
        }

        const selectedOption = answer?.questionOptions.find(
          (option: any) => option.id === answer.selectedOption
        );
        if (!selectedOption) return;

        const scoreValue = selectedOption.score;

        if (dateScoresMap[date][answer.legend] === undefined) {
          dateScoresMap[date][answer.legend] = 0; // Default to 0 instead of null
        }

        dateScoresMap[date][answer.legend] += scoreValue;
      }
    });

    Object.keys(dateScoresMap).forEach((date) => {
      categories.push(date);
      Object.keys(dateScoresMap[date]).forEach((legend) => {
        if (!legends.includes(legend)) {
          legends.push(legend);
        }
      });
    });
    legends.forEach((legend, index) => {
      const legendData: { x: number; y: number }[] = categories
        .map((date) => ({
          x: new Date(moment(date).format("YYYY-MM-DD")).getTime(), // Format date as "DD MMM" (e.g., "25 Feb")
          y: dateScoresMap[date][legend] || 0, // Default to 0 instead of null
        }))
        .filter((dataPoint) => dataPoint.y !== 0); // Exclude data points where x is 0

      series.push({
        name: legend,
        data: legendData,
        type: "line",
      });
    });
  }


  console.log("series",series);
  const options: any = {
    chart: {
      height: 350,
      type: "line",
      zoom: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "straight",
      width: 3,
    },
    markers: {
      size: 4, // Set size to 0 to hide markers
      hover: {
        sizeOffset: 3, // Adjust the size of the marker on hover
      },
    },
    grid: {
      borderColor: "#e0e0e0",
      borderWidth: 1,
      strokeDashArray: 1,
      padding: {
        top: 0,
        right: 30,
        bottom: 0,
        left: 20,
      },
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      markers: {
        width: 20, // Width of the rectangle
        height: 8, // Height of the rectangle
        radius: 2, // Corner radius of the rectangle
        offsetX: 0,
        offsetY: 0,
        strokeWidth: 0, // No stroke around the rectangle
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
    },
    xaxis: {
      type: "datetime",
    },
    yaxis: {
      tickPlacement: "on", // Place ticks between data points
      labels: {
        formatter: (value: number) => {
          const labels = ["0", "1", "2", "3", "4", "5","6", "7", "8", "9"];
          return labels[value];
        },
      },
    },
  };

  return (
    <div>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  );
};
